/* PTB Atelier — étape 5 : récapitulatif complet (article par article), coordonnées, consentement, envoi de la demande, écran de confirmation.
   Aucun succès n'est jamais affiché sans réponse positive du service de réception (qui enregistre la demande et envoie les e-mails). */
(function () {
  'use strict';
  var C = window.PTB_ATELIER_CFG;
  var A = window.PTBAtelier;
  var root = document.getElementById('ptb-atelier-app');
  if (!C || !A || !root || !A.state || !A.steps || !A.t) return;

  var T = A.t, S = A.state, esc = A.util.esc, $ = A.util.$, $$ = A.util.$$, money = A.util.money, imgUrl = A.util.imgUrl;
  var L = C.limits;
  var T0 = Date.now();
  var sending = false;
  A.send = {};

  /* ---------- validation des coordonnées ---------- */
  var EMAIL = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/;
  function cleanName(v) { return String(v || '').replace(/[\u0000-\u001f\u007f<>]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 60); }
  function validateContact() {
    var c = S.contact, e = {};
    if (!cleanName(c.first)) e.first = T('err.first');
    if (!cleanName(c.last)) e.last = T('err.last');
    var mail = String(c.email || '').trim();
    if (!EMAIL.test(mail) || mail.length > 120) e.email = T('err.email');
    var ph = String(c.phone || '').trim();
    if (ph && (!/^[+()\d\s.\-]{6,24}$/.test(ph) || ph.replace(/\D/g, '').length < 6)) e.phone = T('err.phone');
    return e;
  }
  function showFieldErrors(errors) {
    ['first', 'last', 'email', 'phone'].forEach(function (k) {
      var input = $('[data-field="' + k + '"]'), msg = $('[data-err="' + k + '"]');
      if (!input || !msg) return;
      msg.textContent = errors[k] || '';
      if (errors[k]) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    });
  }

  /* ---------- blocs du récapitulatif ---------- */
  function threadsHtml(d) {
    var th = A.threads.of(d);
    return '<ul class="atl-rd__threads">' + th.map(function (t, i) { return '<li><i style="--sw:' + esc(t.hex) + '"></i>' + (i + 1) + '. ' + esc(A.threads.name(t)) + ' <small>' + esc(t.code) + '</small></li>'; }).join('') + '</ul>';
  }
  function designHtml(line) {
    var d = line.d, f = A.fontById(d.font), im = d.img ? A.images[d.img] : null, h = '<div class="atl-rd">';
    if (d.type === 'text') {
      h += '<p class="atl-rd__text" style="font-family:\'' + esc(f.family) + '\',Anton,sans-serif">' + esc(d.text) + '</p><p class="atl-rd__meta">' + esc(T('step5.fontL')) + ' : ' + esc(f.label) + '</p>';
    } else if (d.type === 'image' && im) {
      h += '<div class="atl-rd__img"><img src="' + esc(im.dataUrl) + '" alt="' + esc(im.name) + '"></div><p class="atl-rd__meta">' + esc(T('step5.designImage', { name: im.name })) + ' · ' + im.width + '×' + im.height + ' px · ' + esc(A.util.fmtSize(im.size)) + '</p>';
    }
    var pl = A.placementLabel(line);
    if (pl) h += '<p class="atl-rd__meta">' + esc(T('step5.placementL')) + ' : ' + esc(pl) + '</p>';
    h += '<p class="atl-rd__meta">' + esc(T('step5.sizeL')) + ' : ' + esc(A.sizeText(d)) + '</p>';
    h += '<p class="atl-rd__meta">' + esc(T('step5.threadsL')) + ' :</p>' + threadsHtml(d);
    if (d.instr.trim()) h += '<p class="atl-rd__meta"><b>' + esc(T('step5.instrL')) + ' :</b> ' + esc(d.instr.trim()) + '</p>';
    return h + '</div>';
  }
  function itemsHtml() {
    var infos = A.infos(), many = infos.length > 1;
    return infos.map(function (i, idx) {
      var meta = [i.colorLabel, i.sizeLabel].filter(Boolean).join(' · ');
      return '<li class="atl-ri"><img src="' + esc(imgUrl(i.image, 160)) + '" alt="" width="64" height="80" loading="lazy">' +
        '<div class="atl-ri__main"><b>' + (many ? '<span class="atl-sum__n">' + i.n + '</span> ' : '') + esc(i.title) + '</b>' + (meta ? '<span>' + esc(meta) + '</span>' : '') +
        designHtml(i.line) +
        '<p class="atl-ri__links"><button type="button" class="atl-link" data-action="goto" data-step="3" data-tab="' + idx + '">' + esc(T('step5.editDesign')) + '</button> · <button type="button" class="atl-link" data-action="goto" data-step="4" data-tab="' + idx + '">' + esc(T('step5.editThreads')) + '</button></p></div>' +
        '<div class="atl-ri__nums"><span>' + i.qty + ' × ' + esc(money(i.unit, i.currency)) + '</span><b>' + esc(money(i.total, i.currency)) + '</b></div></li>';
    }).join('');
  }
  function field(id, key, label, type, extra) {
    return '<div class="atl-field"><label for="atl-f-' + id + '">' + esc(label) + '</label>' +
      '<input id="atl-f-' + id + '" class="input" data-field="' + key + '" type="' + type + '" value="' + esc(S.contact[key] || '') + '" ' + (extra || '') + ' aria-describedby="atl-e-' + id + '">' +
      '<p class="atl-err" id="atl-e-' + id + '" data-err="' + key + '"></p></div>';
  }
  function statusHtml() { return '<div class="atl-status" data-role="status" role="alert" aria-live="assertive"></div>'; }
  function setStatus(html, kind) {
    var el = $('[data-role="status"]');
    if (!el) return;
    el.className = 'atl-status' + (kind ? ' atl-status--' + kind : '');
    el.innerHTML = html || '';
  }
  function hasImage() { return S.lines.some(function (l) { return l.d.type === 'image' && l.d.img && A.images[l.d.img]; }); }

  A.steps[5] = {
    render: function (el) {
      var fonts = []; S.lines.forEach(function (l) { if (l.d.type === 'text') fonts.push(A.fontById(l.d.font)); });
      if (fonts.length) A.preview.loadFonts(fonts);
      var previewMode = !C.endpoint, pay = !!C.checkout;
      var privacy = (hasImage() ? esc(T('step5.privacy')) + ' ' + esc(T('step5.retention', { n: L.retentionMonths })) : esc(T('step5.privacyText'))) +
        (C.privacyUrl ? ' <a href="' + esc(C.privacyUrl) + '" target="_blank" rel="noopener">' + esc(T('step5.privacyLink')) + '</a>' : '');
      el.innerHTML =
        '<header class="atl-step__head"><h3 class="atl-h" id="atl-h5">' + esc(T('step5.title')) + '</h3><p class="atl-sub">' + esc(T(pay ? 'step5.sub' : 'step5.subReq')) + '</p></header>' +
        (previewMode ? '<p class="atl-banner" role="note">' + esc(T('step5.previewMode')) + '</p>' : '') +
        '<section class="atl-recap"><div class="atl-recap__h"><h4>' + esc(T(S.lines.length > 1 ? 'step5.itemsMany' : 'step5.items')) + '</h4><button type="button" class="atl-link" data-action="goto" data-step="2">' + esc(T('step5.edit')) + '</button></div><ul class="atl-ri-list">' + itemsHtml() + '</ul></section>' +
        '<section class="atl-recap"><div class="atl-recap__h"><h4>' + esc(T('price.total')) + '</h4></div><div data-role="price5">' + A.priceHtml() + '</div>' +
          '<p class="atl-help">' + esc(T('step5.shipTo', { country: C.countryName || C.country })) + '</p></section>' +
        '<section class="atl-recap"><div class="atl-recap__h"><h4>' + esc(T('step5.contact')) + '</h4></div><div class="atl-form">' +
          '<div class="atl-grid2">' + field('first', 'first', T('f.first'), 'text', 'autocomplete="given-name" maxlength="60" required') + field('last', 'last', T('f.last'), 'text', 'autocomplete="family-name" maxlength="60" required') + '</div>' +
          field('email', 'email', T('f.email'), 'email', 'autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" maxlength="120" required') +
          field('phone', 'phone', T('f.phone'), 'tel', 'autocomplete="tel" inputmode="tel" maxlength="24"') +
          '<div class="atl-field"><label for="atl-f-message">' + esc(T('f.message')) + '</label><textarea id="atl-f-message" class="input atl-textarea" data-field="message" rows="3" maxlength="' + L.instrMax + '" aria-describedby="atl-e-message">' + esc(S.contact.message || '') + '</textarea><p class="atl-help" id="atl-e-message">' + esc(T('f.messageHelp')) + '</p></div>' +
          '<div class="atl-hp" aria-hidden="true"><label>Website<input type="text" data-role="hp" tabindex="-1" autocomplete="off"></label></div>' +
        '</div></section>' +
        '<section class="atl-consent"><label class="atl-check"><input type="checkbox" data-role="consent"' + (S.consent ? ' checked' : '') + ' aria-describedby="atl-consent-err"><span>' + esc(T(pay ? 'step5.consent' : 'step5.consentReq')) + '</span></label>' +
          '<p class="atl-err" id="atl-consent-err" data-err="consent"></p>' +
          '<p class="atl-privacy">' + privacy + '</p></section>' +
        '<div class="atl-send">' + (pay ? '<p class="atl-send__note">' + esc(T('step5.afterSend')) + '</p>' : '') + (pay && C.markerHandle ? '<p class="atl-send__note">' + esc(T('step5.markerNote')) + '</p>' : '') +
          '<button type="button" class="btn btn--gold atl-send__btn" data-action="send">' + esc(T('step5.send')) + '</button>' + statusHtml() + '</div>';
    },
    update: function () { },
    updatePrice: function () { var p = $('[data-role="price5"]'); if (p) p.innerHTML = A.priceHtml(); },
    validate: function () { return { ok: true }; }
  };

  /* ---------- charge utile (version 2 : une personnalisation par article) ---------- */
  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) { /* repli */ }
    var a = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(a);
    return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
  }
  A.send.buildPayload = function () {
    var c = S.contact, est = S.est.data;
    /* images : identifiants courts (img1, img2…) ; une image partagée par plusieurs articles n'est envoyée qu'une fois */
    var imgIds = {}, images = [];
    function imageRef(id) {
      var im = id ? A.images[id] : null;
      if (!im) return null;
      if (!imgIds[id]) {
        imgIds[id] = 'img' + (images.length + 1);
        images.push({ id: imgIds[id], name: im.name, mime: im.type, size: im.size, width: im.width, height: im.height, base64: A.imageBase64(id) });
      }
      return imgIds[id];
    }
    var items = A.infos().map(function (i) {
      var det = i.detail, v = i.variant, p = i.product || {}, d = i.line.d, f = A.fontById(d.font), sz = A.sizeState(d);
      return {
        n: i.n, handle: i.line.handle, refHandle: det.refHandle || p.refHandle || '', productId: det.id, productGid: det.gid, title: i.title, titleFr: p.titleFr || i.title, orderTitle: det.fullTitle || i.title,
        variantId: v.id, variantGid: v.gid, sku: v.sku || '',
        color: i.colorLabel || i.line.color || '', colorFr: det.colorIdx >= 0 ? (v.optionsFr[det.colorIdx] || i.line.color || '') : '',
        size: i.sizeLabel || i.line.size || '', sizeFr: det.sizeIdx >= 0 ? (v.optionsFr[det.sizeIdx] || i.line.size || '') : '',
        qty: i.qty, unitPrice: v.price, currency: v.currency, lineTotal: i.total,
        image: i.image || '', url: location.origin + '/products/' + (det.refHandle || i.line.handle),
        design: {
          type: d.type, text: d.type === 'text' ? d.text.trim() : '',
          font: d.type === 'text' ? { id: f.id, label: f.label, family: f.family } : null,
          placement: d.place || '', size: sz.mode === 'custom' && sz.ok ? { mode: 'custom', widthCm: sz.w, heightCm: sz.h } : { mode: 'auto' },
          instructions: d.instr.trim().slice(0, L.instrMax),
          threads: A.threads.of(d).map(function (t) { return { id: t.id, code: t.code, name: t.name.fr, hex: t.hex }; }),
          imageId: d.type === 'image' ? imageRef(d.img) : null
        }
      };
    });
    if (!A.requestId) A.requestId = uuid();
    return {
      v: 2, lang: C.lang, siteKey: C.siteKey, requestId: A.requestId,
      hp: ($('[data-role="hp"]') || {}).value || '', t: Date.now() - T0,
      contact: { first: cleanName(c.first), last: cleanName(c.last), email: String(c.email || '').trim(), phone: String(c.phone || '').trim(), message: String(c.message || '').trim().slice(0, L.instrMax) },
      country: C.country, currency: C.currency,
      same: !!(S.same && S.lines.length > 1),
      items: items, images: images,
      estimate: est ? { currency: est.currency, subtotal: est.before, discount: est.discount, discountTitles: est.discountTitles, shipping: est.shipping, freeShipping: est.freeShip, shippingTitle: est.shippingTitle, total: est.total, country: est.country } : null,
      page: location.origin + location.pathname
    };
  };

  /* ---------- paiement sécurisé Shopify ----------
     Après l'enregistrement de la demande, le client est envoyé sur le paiement Shopify pour la valider.
     Panier dédié (variantes réelles, prix du site, aucun supplément, aucune remise de pack) ; la personnalisation de CHAQUE article
     voyage dans les propriétés de sa ligne. */
  function clip250(x) { x = String(x === null || x === undefined ? '' : x); return x.length > 250 ? x.slice(0, 249) + '…' : x; }
  function lineAttrs(info, ref) {
    var d = info.line.d, f = A.fontById(d.font), im = d.img ? A.images[d.img] : null, out = [];
    out.push({ key: T('co.custom'), value: clip250(d.type === 'text' ? '« ' + d.text.trim() + ' »' : T('step5.designImage', { name: im ? im.name : '' })) });
    if (d.type === 'text') out.push({ key: T('co.font'), value: clip250(f.label) });
    out.push({ key: T('co.threads'), value: clip250(A.threads.of(d).map(function (t, i) { return (i + 1) + '. ' + A.threads.name(t) + ' (' + t.code + ')'; }).join(' · ')) });
    var pl = A.placementLabel(info.line);
    if (pl) out.push({ key: T('co.place'), value: clip250(pl) });
    out.push({ key: T('co.size'), value: clip250(A.sizeText(d, true)) });
    if (d.instr.trim()) out.push({ key: T('co.instr'), value: clip250(d.instr.trim().replace(/\s+/g, ' ')) });
    if (S.lines.length > 1) out.push({ key: T('co.item'), value: String(info.n) + '/' + S.lines.length });
    if (ref) { out.push({ key: T('co.ref'), value: ref }); out.push({ key: '_atelier_ref', value: ref }); }
    out.push({ key: '_atelier_id', value: A.requestId });
    return out;
  }
  A.send.lineAttrs = lineAttrs;
  /* propriétés de la ligne marqueur (0 €) : référence de la demande, visible dans le paiement et dans la commande */
  function markerAttrs(ref) {
    var out = [];
    if (ref) { out.push({ key: T('co.ref'), value: ref }); out.push({ key: '_atelier_ref', value: ref }); }
    out.push({ key: '_atelier_id', value: A.requestId });
    return out;
  }
  function safeCheckoutUrl(u) {
    try {
      var x = new URL(u, location.href), h = x.hostname.toLowerCase(), base = String(C.shopHost || location.hostname).toLowerCase();
      return x.protocol === 'https:' && (h === base || h.slice(-(base.length + 1)) === '.' + base || /\.myshopify\.com$/.test(h) || h === location.hostname.toLowerCase());
    } catch (e) { return false; }
  }
  /* une même demande (contenu identique) garde le même identifiant et le même panier d'un essai à l'autre */
  function signature() {
    var c = S.contact;
    return JSON.stringify({
      i: S.lines.map(function (l) {
        var im = l.d.img && A.images[l.d.img];
        return [l.handle, l.color, l.size, l.qty, l.d.type, l.d.text, l.d.font, l.d.instr, l.d.place, l.d.threads, im ? [im.name, im.size] : null];
      }),
      s: S.same, c: [c.first, c.last, c.email, c.phone, c.message], co: !!C.checkout
    });
  }
  function prepareCheckout() {
    if (A.checkout && A.checkout.sig === A._sig) return Promise.resolve(A.checkout);
    var est = S.est.data, phone = String(S.contact.phone || '').replace(/[\s().\-]/g, ''), markerGid = null;
    return A.data.loadMarker().then(function (marker) {
      var lines = A.infos().map(function (i) { return { gid: i.variant.gid, qty: i.qty, attrs: lineAttrs(i, null) }; });
      if (marker) { markerGid = marker.gid; lines.push({ gid: marker.gid, qty: 1, attrs: markerAttrs(null) }); }
      return A.data.createCheckout({
        lines: lines,
        attrs: [{ key: 'atelier_id', value: A.requestId }],
        email: String(S.contact.email || '').trim(),
        phone: /^\+\d{8,15}$/.test(phone) ? phone : '',
        codes: est && est.freeShip ? [C.freeShipCode || 'FREESHIP'] : []
      });
    }).then(function (cart) {
      A.checkout = { sig: A._sig, cartId: cart.cartId, url: cart.checkoutUrl, lines: cart.lines, markerGid: markerGid };
      return A.checkout;
    }).catch(function (e) { var err = new Error((e && e.message) || 'cart'); err.kind = 'cart'; throw err; });
  }
  /* ajoute la référence de la demande aux propriétés des lignes et à la note de commande (non bloquant) */
  function finishCheckout(cart, ref) {
    if (!cart) return Promise.resolve();
    var taken = {}, lines = [];
    A.infos().forEach(function (info) {
      for (var k = 0; k < cart.lines.length; k++) {
        if (!taken[k] && cart.lines[k].merchandiseId === info.variant.gid) { taken[k] = 1; lines.push({ id: cart.lines[k].id, attributes: lineAttrs(info, ref) }); break; }
      }
    });
    if (cart.markerGid) {
      for (var m = 0; m < cart.lines.length; m++) {
        if (cart.lines[m].merchandiseId === cart.markerGid) { lines.push({ id: cart.lines[m].id, attributes: markerAttrs(ref) }); break; }
      }
    }
    var done = A.data.tagCheckout(cart.cartId, lines, [{ key: 'atelier_id', value: A.requestId }, { key: 'atelier_ref', value: ref }], 'Atelier PTB — demande ' + ref).catch(function () { /* le panier porte déjà _atelier_id */ });
    return Promise.race([done, new Promise(function (r) { setTimeout(r, 6000); })]);
  }

  /* ---------- envoi ---------- */
  function fail(key, vars, extraHtml) {
    var contact = C.contactUrl ? ' <a href="' + esc(C.contactUrl) + '">' + esc(T('err.send.contactLink')) + '</a>' : '';
    setStatus('<p>' + esc(T(key, vars)) + '</p>' + (extraHtml || '') + (C.contactUrl ? '<p>' + esc(T('err.send.contact')) + contact + '</p>' : ''), 'error');
  }
  function setBusy(on) {
    sending = on;
    $$('[data-action="send"]').forEach(function (b) {
      b.disabled = on; b.setAttribute('aria-busy', String(on));
      if (b.classList.contains('atl-send__btn')) b.textContent = on ? T('step5.sending') : T('step5.send');
    });
  }

  A.send.submit = function () {
    if (sending) return;
    setStatus('');
    /* 1. étapes précédentes */
    for (var i = 1; i <= 4; i++) {
      var v = A.steps[i].validate();
      if (!v.ok) {
        var tabAttr = typeof v.tab === 'number' ? ' data-tab="' + v.tab + '"' : '';
        setStatus('<p>' + esc(T('err.stepsIncomplete', { step: T('step.' + i) })) + ' ' + esc(v.msg || '') + '</p><p><button type="button" class="atl-link" data-action="goto" data-step="' + i + '"' + tabAttr + '>' + esc(T('step5.edit')) + ' → ' + esc(T('step.' + i)) + '</button></p>', 'error');
        return;
      }
    }
    /* 2. coordonnées + consentement */
    var errors = validateContact();
    showFieldErrors(errors);
    var consentErr = $('[data-err="consent"]');
    if (consentErr) consentErr.textContent = S.consent ? '' : T('err.consent');
    var firstErr = ['first', 'last', 'email', 'phone'].filter(function (k) { return errors[k]; })[0];
    if (firstErr) { var inp = $('[data-field="' + firstErr + '"]'); if (inp) inp.focus(); return; }
    if (!S.consent) { var cb = $('[data-role="consent"]'); if (cb) cb.focus(); return; }
    /* 3. service de réception configuré ? sinon on le dit, sans rien simuler */
    if (!C.endpoint) { setStatus('<p>' + esc(T('step5.disabled')) + '</p>', 'error'); return; }
    var sig = signature();
    if (sig !== A._sig) { A._sig = sig; A.requestId = null; A.checkout = null; }
    if (!A.requestId) A.requestId = uuid();
    setBusy(true);
    setStatus('<p>' + esc(T(C.checkout ? 'step5.preparing' : 'step5.sending')) + '</p>', 'info');
    var ctl = window.AbortController ? new AbortController() : null, timer = null;
    /* 4. panier de paiement (si activé) puis envoi de la demande : sans panier prêt, rien n'est envoyé */
    (C.checkout ? prepareCheckout() : Promise.resolve(null)).then(function (cart) {
      var payload = A.send.buildPayload();
      if (cart) payload.checkout = { url: cart.url, cartId: cart.cartId };
      setStatus('<p>' + esc(T('step5.sending')) + '</p>', 'info');
      timer = setTimeout(function () { if (ctl) ctl.abort(); }, 120000);
      return fetch(C.endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), redirect: 'follow', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.text().then(function (txt) { var j = null; try { j = JSON.parse(txt); } catch (e) { /* réponse non JSON */ } return { status: r.status, json: j }; }); })
        .then(function (res) {
          clearTimeout(timer);
          var j = res.json;
          if (j && j.ok && j.ref) {
            return finishCheckout(cart, j.ref).then(function () { setBusy(false); A.send.showSuccess(j, payload.contact.email, cart); });
          }
          setBusy(false);
          var code = j && j.error;
          if (code === 'rate') fail('err.send.rate');
          else if (code === 'spam') fail('err.send.spam');
          else if (code === 'invalid' || code === 'file') fail('err.send.invalid', { msg: (j && j.message) || '' });
          else fail('err.send.server');
        }, function () { clearTimeout(timer); setBusy(false); fail('err.send.network'); });
    }).catch(function (e) {
      clearTimeout(timer); setBusy(false);
      if (e && e.kind === 'cart') fail('err.send.cart', { msg: e.message }); else fail('err.send.server');
    });
  };

  /* ---------- confirmation puis paiement sécurisé ---------- */
  A.send.showSuccess = function (res, email, cart) {
    var host = $('[data-role="step"]');
    if (!host) return;
    var pay = cart && cart.url && safeCheckoutUrl(cart.url) ? cart.url : '';
    var mailOk = !res.mail || res.mail.customer !== false;
    root.classList.add('is-done');
    A.hideNav(true);
    A.notice('');
    A.clearStored();
    host.innerHTML =
      '<div class="atl-done"><div class="atl-done__mark" aria-hidden="true">✓</div>' +
      '<h3 class="atl-h" tabindex="-1">' + esc(T('ok.title')) + '</h3>' +
      '<p class="atl-done__lead">' + esc(T('ok.body')) + '</p>' +
      '<p class="atl-done__ref"><span>' + esc(T('ok.ref')) + '</span><b dir="ltr">' + esc(res.ref) + '</b></p>' +
      (pay ? '<div class="atl-done__pay"><h4>' + esc(T('ok.last')) + '</h4><p>' + esc(T('ok.lastText')) + '</p><a class="btn btn--gold" data-role="pay" href="' + esc(pay) + '">' + esc(T('ok.pay')) + '</a><p class="atl-done__redirect" role="status">' + esc(T('ok.redirect')) + '</p></div>' : '') +
      '<p class="atl-done__mail' + (mailOk ? '' : ' is-warn') + '">' + esc(mailOk ? T(pay ? 'ok.mailSentPay' : 'ok.mailSent', { email: email || '' }) : T('ok.mailFailed')) + '</p>' +
      '<h4>' + esc(T('ok.next')) + '</h4><ol class="atl-done__steps"><li>' + esc(T(pay ? 'ok.n1' : 'ok.q1')) + '</li><li>' + esc(T(pay ? 'ok.n2' : 'ok.q2')) + '</li><li>' + esc(T(pay ? 'ok.n3' : 'ok.q3')) + '</li></ol>' +
      '<div class="atl-done__btns"><a class="btn btn--outline" href="' + esc(C.homeUrl || '/') + '">' + esc(T('ok.shop')) + '</a>' + (pay ? '' : '<button type="button" class="btn btn--outline" data-action="new-request">' + esc(T('ok.new')) + '</button>') + '</div></div>';
    var h = host.querySelector('.atl-h');
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    var top = root.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    A.requestId = null; A.checkout = null; A._sig = null;
    var prog = $('[data-role="progress-now"]'); if (prog) prog.textContent = '';
    if (pay) { clearTimeout(A._redirectTimer); A._redirectTimer = setTimeout(function () { window.location.assign(pay); }, 2200); }
  };

  /* ---------- événements ---------- */
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.getAttribute) return;
    var k = t.getAttribute('data-field');
    if (!k) return;
    S.contact[k] = t.value;
    if (t.getAttribute('aria-invalid')) { var errs = validateContact(); showFieldErrors(Object.keys(errs).reduce(function (o, x) { if (x === k) o[x] = errs[x]; return o; }, {})); }
    A.changed({ skipUpdate: true });
  });
  root.addEventListener('focusout', function (e) {
    var t = e.target, k = t && t.getAttribute && t.getAttribute('data-field');
    if (!k || k === 'message') return;
    var errs = validateContact();
    var only = {}; only[k] = errs[k] || '';
    showFieldErrors(only);
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-role="consent"]')) {
      S.consent = t.checked;
      var c = $('[data-err="consent"]'); if (c && t.checked) c.textContent = '';
    }
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-action]');
    if (!b || !root.contains(b)) return;
    var act = b.getAttribute('data-action');
    if (act === 'send') { A.send.submit(); return; }
    if (act === 'new-request') { clearTimeout(A._redirectTimer); root.classList.remove('is-done'); A.restartAll(); }
  });
})();
